import type fr from "./runtime_fr";

const en: typeof fr = {
  "runtime.invalid_json": (position: string) => `Error in the JSON structure ${position}`,
};

export default en;
